var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-items-center gl-gap-3"},[(_vm.showNewButton)?_c('gl-button',{attrs:{"to":{ name: _vm.newButtonProps.route },"variant":_vm.newButtonVariant}},[_vm._v("\n    "+_vm._s(_vm.newButtonProps.label)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }